module.exports = __webpack_public_path__ + "static/img/1_5_2.f11a8265.jpg";